export const headerHeight = '72px';
export const headerBoxShadow = '0px 0px 10px #ccc';
export const logoWidth = '150px';
export const sideBar = '250px';
export const arrowDimentions = '30px';
export const topBarHeight = '50px'